/**
 * @module $_GP.fn.slick
 * @example
	$_GP.fn.slick.slickSimple('#slick-element', {
		arrows: true,
		cssEase: 'ease',
		centerMode: false,
		dots: false,
		draggable: true,
	});
 * @returns {object} slicks objects
 * @property {object} slick.slickSimple
 * @property {object} slick.slickFull
 */
export default function slick() {
	/**
	 * Slick with 3 visible items
	 * @param {string} elm - base element
	 * @param {object} opt - slick options
	 * @returns {object} slick object
	 */
	const slick_3 = function(elm, opt) {
		elm = $(elm);
		opt = opt || {};
		if (!elm.length) return;

		const dataOpt = elm.data('slick') || {};

		const defaults = {
			infinite: true,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 3,
			autoplay: false,
			autoplaySpeed: 5000,
			arrows: false,
			dots: true,
			responsive: [
				{
					breakpoint: 768,
					settings: { slidesToShow: 2, slidesToScroll: 2}
				},
				{
					breakpoint: 480,
					settings: { slidesToShow: 1, slidesToScroll: 1}
				}
			]
		};

		const options = $.extend({}, defaults, dataOpt, opt);

		return elm.slick(options);
	};

	/**
	 * Slick with 6 visible items
	 * @param {string} elm - base element
	 * @param {object} opt - slick options
	 * @returns {object} slick object
	 */
	const slick_6 = function(elm, opt) {
		elm = $(elm);
		opt = opt || {};
		if (!elm.length) return;

		const dataOpt = elm.data('slick') || {};

		const defaults = {
			infinite: true,
			lazyLoad: 'ondemand',
			speed: 300,
			slidesToShow: 6,
			slidesToScroll: 1,
			autoplay: false,
			autoplaySpeed: 5000,
			responsive: [
				{
					breakpoint: 1200,
					settings: { slidesToShow: 5}
				},
				{
					breakpoint: 992,
					settings: { slidesToShow: 4}
				},
				{
					breakpoint: 768,
					settings: { slidesToShow: 3}
				},
				{
					breakpoint: 480,
					settings: { slidesToShow: 2}
				}
			]
		};

		const options = $.extend({}, defaults, dataOpt, opt);

		return elm.slick(options);
	};

	/**
	 * Slick for sidebar
	 * @param {string} elm - base element
	 * @param {object} opt - slick options
	 * @returns {object} slick object
	 */
	const slickSidebar = function(elm, opt) {
		elm = $(elm);
		opt = opt || {};
		if (!elm.length) return;

		const dataOpt = elm.data('slick') || {};

		const defaults = {
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			autoplaySpeed: 5000,
			responsive: [
				{
					breakpoint: 992,
					settings: { slidesToShow: 2}
				},
				{
					breakpoint: 480,
					settings: { slidesToShow: 1}
				}
			]
		};

		const options = $.extend({}, defaults, dataOpt, opt);

		return elm.slick(options);
	};

	return { slick_3, slick_6, slickSidebar };
}
